import { HeadingItem } from 'components'
import { TiHiEditor } from 'components/verify-item'
import { ItemDetailInfo } from 'components/item-verification'
import { TiHiRolloutContext, TripContext } from 'contexts'
import React, { FC, useContext } from 'react'
import { LineItem, Order, OrderItem } from 'services/types'
import './verify-item-details.scss'
import { useOrderItemService } from 'services';

type Props = {
    stopId: number | undefined
    tripId: number | undefined
    lineItemId: number | undefined
}

export const VerifyItemDetails: FC<Props> = ({ stopId, tripId, lineItemId }) => {
    const tripContext = useContext(TripContext)
    const { isEligible: isTiHiEligible } = useContext(TiHiRolloutContext)

    const orders: Order[] = tripContext.orders.filter(o => o.stopId == stopId)
    let items: OrderItem[] = []

    orders.forEach(order => {
        items = [...items, ...tripContext.orderItems.filter(oi => oi.orderId == order.id && oi.lineItemId == lineItemId)]
    })

    const orderItem: OrderItem = items.length > 0 ? items[0] : {} as OrderItem
    const lineItem: LineItem = tripContext.lineItems.find(li => li.id == orderItem.lineItemId) ?? {} as LineItem

    const totalQuantity = (): number => {
        let total: number = 0
        items.forEach(item => { total += item.shippedQuantity })
        return total
    }

    const isValidTiHi = (): boolean => orderItem.ti != null && orderItem.hi != null

    const { getOtherDeliveriesWithItem } = useOrderItemService()

    const otherCompaniesWithTheSameOrderItem: string[] = getOtherDeliveriesWithItem(stopId, tripId, lineItemId);

    return (
        <div className={'card-material'}>
            <HeadingItem text={`Customer Item ID : ${orderItem.customerItemId ?? 'N/A'}`} />
            <div className={'verify-item-details-description'}>{lineItem.longDescription ?? (lineItem.description ?? 'No description available')}</div>
            <div className={'verify-item-details'}>
                <ItemDetailInfo title={'Dot Item ID'} value={lineItem.id} position={'left'} />
                <ItemDetailInfo title={'Manufacturer Item ID'} value={lineItem.manufacturerItemId ?? 'No manufacturer item ID available'} position={'left'} />
                <ItemDetailInfo title={'UPC'} value={lineItem.universalProductCode} position={'left'} />
                {isTiHiEligible
                    ? <TiHiEditor orderItems={items} />
                    : isValidTiHi() && <ItemDetailInfo title={'Ti / Hi'} value={`${orderItem.ti} / ${orderItem.hi} ${orderItem.palletSize ?? ''}`} position={'left'} textColor={'app-color'} />
                }
                {otherCompaniesWithTheSameOrderItem.length > 0 && <ItemDetailInfo title={'This item is also on customer(s):'} value={otherCompaniesWithTheSameOrderItem.join(", ")} position={'left'} textColor={'red'} />}
            </div>
            {items.length > 1 &&
                <div className={'verify-item-footer-container'}>
                    <div className={`verify-item-footer-left`}> Total PO : {items.length}</div>
                    <div className={`verify-item-footer-right`}> Total Cases : {totalQuantity()}</div>
                </div>
            }
        </div>

    )
}
